import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="event-performance-chart"
export default class extends Controller {
  static targets = ["chartContainer"]
  static values = { url: String }

  updateChart(event) {
    const sortBy = event.target.value
    const url = `${this.urlValue}/event_performance_chart?sort_by=${sortBy}`

    // Add some debugging to ensure we're targeting the right element
    console.log("Updating event performance chart with sort_by:", sortBy)
    console.log("Target container:", this.chartContainerTarget)

    get(url, {
      responseKind: "turbo-stream"
    }).then(() => {
      console.log("Chart update completed")
    }).catch((error) => {
      console.error("Chart update failed:", error)
    })
  }
}